import React, { useContext } from "react";

import { ActionPlanView, SurveySegment } from '../../../amorg-common';
import { updateActionPlanData } from "../../../api/actionPlanClientApi";
import { LoadingPageOverlay } from "../../../designSystem/LoadingPageOverlay";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { ProtectedPageContext } from "../../_contexts/ProtectedPageContext";
import { EditableSegmentPanel } from "../../workplaceassessments/[activityId]/_components/tabs/_components/EditableSegmentPanel";
import { ReadOnlySegmentPanel } from "../../workplaceassessments/[activityId]/_components/tabs/_components/ReadOnlySegmentPanel";

type ActionPlanSurveySegmentPanelProps = {
    activityId: string,
    actionPlan: ActionPlanView,
    onActionPlanUpdated: () => void;
};


export function ActionPlanSurveySegmentPanel (props: ActionPlanSurveySegmentPanelProps): JSX.Element
{
    const [loading, setLoading] = React.useState(true);
    const [selectedSegments, setSelectedSegments] = React.useState<SurveySegment[][]>([]);

    const activeUser = useContext(ProtectedPageContext).user;


    const segmentReport = props.actionPlan.type === 'WPA'
        ? props.actionPlan.surveyData.segmentReport
        : [];


    React.useEffect(() =>
    {
        const getData = async () =>
        {
            if (props.actionPlan.type !== 'WPA')
                console.log('Component should only render for WPAs');
            else
            {
                if (activeUser.permissionGroupId === 'user')
                    setSelectedSegments(props.actionPlan.customData.segmentFilter);
            }

            setLoading(false);
        };
        getData();

    }, [props.actionPlan]);

    async function handleFilterChanged (filter: SurveySegment[][])
    {
        setLoading(true);
        if ((await updateActionPlanData(props.actionPlan.id, { type: 'WPA', customData: { segmentFilter: filter } })).isSuccess)
            props.onActionPlanUpdated();
    }

    return (
        <>
            <LoadingPageOverlay loading={loading} />


            <Flex flexDirection="column" gap={4}>
                {!loading && activeUser.permissionGroupId === 'user' &&
                    <ReadOnlySegmentPanel segmentLists={selectedSegments} lockedView="pills" />
                }
                {activeUser.permissionGroupId !== 'user' && props.actionPlan.type === 'WPA' &&
                    <div>
                        <EditableSegmentPanel
                            segmentLists={segmentReport}
                            selection={props.actionPlan.customData.segmentFilter}
                            onSelectionChange={handleFilterChanged}
                            noSelectionContent={<span>Vælg et eller flere segmenter for at kunne vælge emner fra spørgeskemaet.</span>}
                        />
                    </div>
                }
            </Flex>
        </>
    );
}